module.exports = __webpack_public_path__ + "04ef0d76c3eade65bd63e1276152e80d.png";